import React, { useState } from 'react';
import { HandoffChecklistV2 } from '../handoff-checklist-v2/handoff-checklist-v2';
import { useMessagingAirHandoffMetrics } from './hooks/use-messaging-air-handoff-metrics';
import { ChecklistMetricItem } from '../handoff-checklist-v2/handoff-checklist-v2.types';

interface MessagingAirHandoffProps {
  handoffId?: string;
  onCancel: () => void;
  onSaveAndClose: (notes: string) => void;
  onSubmit: (notes: string, metrics: ChecklistMetricItem[]) => void;
  isSaving?: boolean;
  isSubmitting?: boolean;
  initialNotes?: string;
}

export const MessagingAirHandoff = ({
  handoffId,
  onCancel,
  onSaveAndClose,
  onSubmit,
  isSaving = false,
  isSubmitting = false,
  initialNotes = '',
}: MessagingAirHandoffProps) => {
  const { metrics, refresh, isLoading, error } = useMessagingAirHandoffMetrics(handoffId);
  const [notes, setNotes] = useState<string>(initialNotes);

  return (
    <HandoffChecklistV2
      metrics={metrics}
      title="Messaging AI Receptionist"
      notes={notes}
      onNotesChange={setNotes}
      onCancel={onCancel}
      onSaveAndClose={() => onSaveAndClose(notes)}
      onSubmit={() => onSubmit(notes, metrics)}
      onRefresh={refresh}
      isSaving={isSaving}
      isSubmitting={isSubmitting}
      isLoading={isLoading}
      error={error}
      successMessage="Looks like all AI Receptionist checks are good to go."
    />
  );
};
